import { UserGroup } from "../backend";

export function isManageableGroup(group?: UserGroup) {
  return !isEveryoneGroup(group);
}

export function isEveryoneGroup(group?: UserGroup) {
  return group?.name === "Everyone";
}
